<template>
	<div class="wrap">
		<Title :title="vacationName"></Title>
		<div class="activity-form-wrap">
			<el-form :model="formInfo" :inline="true" class="activity-form">
				<el-form-item label="姓名">
					<el-input v-model="formInfo.userName" placeholder="请输入姓名" clearable></el-input>
				</el-form-item>
				<el-form-item label="昵称">
					<el-input v-model="formInfo.nickName" placeholder="请输入昵称" clearable></el-input>
				</el-form-item>
				<el-form-item label="电话">
					<el-input v-model="formInfo.memberPhone" placeholder="请输入手机号" clearable></el-input>
				</el-form-item>
				<el-form-item label="学校">
					<el-input v-model="formInfo.school" placeholder="请输入学校名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="报名日期">
					<el-date-picker align="center" v-model="formInfo.enrollTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择报名时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="星标用户">
					<el-select v-model="formInfo.starFlag" @change="setSelectedType">
						<el-option label="全部" value=""></el-option>
						<el-option label="标星" value="1"></el-option>
						<el-option label="未标星" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item >
					<el-button v-if="!proviceId" size="mini" type="primary" @click="toSelectCity">选择返乡城市</el-button>
					<el-button v-else size="mini" type="primary" @click="toSelectCity">{{proviceName}}<span v-if="cityName">,{{cityName}}</span><span v-if="countryName">,{{countryName}}</span></el-button>
				</el-form-item>

        <el-form-item label="返乡地址">
					<el-input v-model="formInfo.returnAddress" placeholder="请输入返乡地址" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
					<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="export-wrap">
			<div class="export-wrap-l">
				<el-button :class="currentIndex==0?'current':''" size="mini" type="primary" @click="changeTab(0)">({{countModel.auditStatusAll}})全部</el-button>
				<el-button :class="currentIndex==1?'current':''" size="mini" type="primary" @click="changeTab(1)">({{countModel.auditStatus0}})未审核</el-button>
				<el-button :class="currentIndex==2?'current':''" size="mini" type="primary" @click="changeTab(2)">({{countModel.auditStatus1}})审核通过</el-button>
				<el-button :class="currentIndex==3?'current':''" size="mini" type="primary" @click="changeTab(3)">({{countModel.joinStatus1}})确认参加</el-button>
				<el-button :class="currentIndex==4?'current':''" size="mini" type="primary" @click="changeTab(4)">({{countModel.joinStatus0}})未确认</el-button>
			</div>
			<div class="export-wrap-r">
				<el-button size="mini" type="primary" @click="downAddress()">导出配送地址</el-button>
				<div class="upload-logistics">
					<el-button  size="mini" type="primary" @click="">上传物流信息</el-button>
					<input type="file" accept=".xls, .xlsx" ref="fileInput" @change="uploadFile">
				</div>


				<el-button  size="mini" type="primary" @click="downJoin()">导出入选信息</el-button>
				<el-button  size="mini" type="primary" @click="toRemindCheck(1)">({{countModel.confirmRemindNum}})审核未确认信息</el-button>
				<el-button  size="mini" type="primary" @click="toRemindCheck(2)">({{countModel.taskRemindNum}})任务未完成提醒</el-button>
			</div>
		</div>
		<el-table border size="mini" :data="dataList" style="width: 100%" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="50">
			</el-table-column>
			<el-table-column prop="memberName" label="星标" width="50">
				<template slot-scope="scope">
					<span class="star-icon el-icon-star-on"></span>
				</template>
			</el-table-column>
			<el-table-column prop="userName" label="姓名" width="80">
			</el-table-column>
			<el-table-column prop="nickName" label="昵称" width="80">
			</el-table-column>
			<el-table-column label="学校信息">
				<template slot-scope="scope">
					学校：{{scope.row.school}} 专业：{{scope.row.major}} 年级：{{scope.row.grade}}
				</template>
			</el-table-column>
			<el-table-column label="前往地点">
				<template slot-scope="scope">
					{{scope.row.provinceName}} {{scope.row.cityName}} {{scope.row.returnAddress}}
				</template>
			</el-table-column>
			<el-table-column prop="showPhone" label="手机号码" width="100">
			</el-table-column>
			<el-table-column label="状态" width="130">
				<template slot-scope="scope">
					<span v-if="scope.row.auditStatus=='0'">待审核</span>
					<span v-if="scope.row.auditStatus=='1'">审核通过</span>
					<span v-if="scope.row.auditStatus=='2'">审核未通过</span>
          <span v-if="scope.row.auditStatus=='1'">
            <span v-if="scope.row.joinStatus=='1'"> / 确认参加</span>
            <span v-if="scope.row.joinStatus=='0'"> / 未确认</span>
          </span>
				</template>
			</el-table-column>
			<el-table-column prop="addTime" label="报名时间" width="100">
				<template slot-scope="scope">
					{{scope.row.addTime | datefmt2('YYYY-MM-DD')}}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="操作" width="120">
				<template slot-scope="scope">
					<div class="manage-btns">
						<span v-if="scope.row.auditStatus==1" @click="toDetail(scope.row,2)">查看物流 | </span>
            <span v-if="scope.row.isLogisticsFlag==1&&(scope.row.auditStatus==0||scope.row.auditStatus==2)" @click="toDetail(scope.row, 3)">审核邮寄 | </span>
            <span v-if="scope.row.isLogisticsFlag==0&&(scope.row.auditStatus==0||scope.row.auditStatus==2)" @click="toDetail(scope.row, 4)">审核 | </span>
<!--						<span v-if="scope.row.auditStatus==0||scope.row.auditStatus==2" @click="toDetail(scope.row, 3)">审核邮寄 | </span>-->
						<!-- <span v-if="scope.row.auditStatus==1" class="space">|</span>
						<span v-if="scope.row.isLogisticsFlag==1&&(scope.row.auditStatus==0||scope.row.auditStatus==2)" class="space">|</span> -->
						<span @click="toDetail(scope.row,1)">详情</span>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		<!--详情弹窗-->
		<el-dialog title="报名表详情" :visible.sync="enrollDialog" width="50%" @close="enrollDialog=false">
			<table class="table-column2">
				<tr>
					<th>假期名称</th>
					<td>{{detailModel.vacationName}}</td>
				</tr>
				<tr>
					<th>姓名</th>
					<td>{{detailModel.userName}}</td>
				</tr>
				<tr>
					<th>学校</th>
					<td>{{detailModel.school}}</td>
				</tr>
				<tr>
					<th>年级</th>
					<td>{{detailModel.grade}}</td>
				</tr>
				<tr>
					<th>学生证</th>
					<td>
						<img v-if="detailModel.cardFileUrl" :src="detailModel.cardFileUrl"/>
					</td>
				</tr>
				<tr>
					<th>专业</th>
					<td>{{detailModel.major}}</td>
				</tr>
				<tr>
					<th>省份名称</th>
					<td>{{detailModel.provinceName}}</td>
				</tr>
				<tr>
					<th>城市名称</th>
					<td>{{detailModel.cityName}}</td>
				</tr>
				<tr>
					<th>区县名称</th>
					<td>{{detailModel.districtName}}</td>
				</tr>
				<tr>
					<th>详细地址</th>
					<td>{{detailModel.returnAddress}}</td>
				</tr>
				<tr>
					<th>身份证号</th>
					<td>{{detailModel.idCard}}</td>
				</tr>
				<tr>
					<th>会员电话</th>
					<td>{{detailModel.showPhone}}</td>
				</tr>
				<tr>
					<th>审核状态</th>
					<td>
						<span v-if="detailModel.auditStatus=='0'">待审核</span>
						<span v-if="detailModel.auditStatus=='1'">审核通过</span>
						<span v-if="detailModel.auditStatus=='2'">审核未通过</span>
					</td>
				</tr>
				<tr>
					<th>参加状态</th>
					<td>
						<span v-if="detailModel.joinStatus=='1'">确认参加</span>
						<span v-if="detailModel.joinStatus=='0'">未确认</span>
					</td>
				</tr>
			</table>
		</el-dialog>
		<!--审核邮寄弹窗-->
		<el-dialog title="确定审核通过该报名吗？" :visible.sync="checkDialog" width="50%" @close="checkDialog=false">
			<table class="table-column2">
				<tr>
					<th>假期名称</th>
					<td>{{detailModel.vacationName}}</td>
				</tr>
				<tr>
					<th>姓名</th>
					<td>{{detailModel.userName}}</td>
				</tr>
				<tr>
					<th>学校</th>
					<td>{{detailModel.school}}</td>
				</tr>
				<tr>
					<th>年级</th>
					<td>{{detailModel.grade}}</td>
				</tr>
				<tr>
					<th>学生证</th>
					<td>
						<img v-if="detailModel.cardFileUrl" :src="detailModel.cardFileUrl"/>
					</td>
				</tr>
				<tr>
					<th>专业</th>
					<td>{{detailModel.major}}</td>
				</tr>
				<tr>
					<th>省份名称</th>
					<td>{{detailModel.provinceName}}</td>
				</tr>
				<tr>
					<th>城市名称</th>
					<td>{{detailModel.cityName}}</td>
				</tr>
				<tr>
					<th>区县名称</th>
					<td>{{detailModel.districtName}}</td>
				</tr>
				<tr>
					<th>详细地址</th>
					<td>{{detailModel.returnAddress}}</td>
				</tr>
				<tr>
					<th>身份证号</th>
					<td>{{detailModel.idCard}}</td>
				</tr>
				<tr>
					<th>会员电话</th>
					<td>{{detailModel.memberPhone}}</td>
				</tr>
				<tr>
					<th>审核状态</th>
					<td>
						<span v-if="detailModel.auditStatus=='0'">未审核</span>
						<span v-if="detailModel.auditStatus=='1'">审核通过</span>
						<span v-if="detailModel.auditStatus=='2'">审核未通过</span>
					</td>
				</tr>
				<tr>
					<th>参加状态</th>
					<td>
						<span v-if="detailModel.joinStatus=='1'">确认参加</span>
						<span v-if="detailModel.joinStatus=='0'">未确认</span>
					</td>
				</tr>
			</table>
			<el-form style="margin-top: 20px;" :inline="true" class="add-dialog">
				<el-form-item label="短信提醒内容" label-width="170px">
					<el-input :rows="4" type="textarea" disabled
						v-model="checkLogisticsCnt"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="flex-end">
						<el-button size="mini" type="primary" @click="checkDialog=false">取消</el-button>
						<el-button size="mini" type="primary" @click="toConfirmLog">确定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!--查看物流弹窗-->
		<el-dialog title="物流详情" :visible.sync="logisticsDialog" width="50%" @close="logisticsDialog=false">
			<table class="table-column2">
				<tr>
					<th>收货人</th>
					<td>{{detailModel.consignee}}</td>
				</tr>
				<tr>
					<th>收货人电话</th>
					<td>{{detailModel.consigneePhone}}</td>
				</tr>
				<tr>
					<th>快递名称</th>
					<td>{{detailModel.expName}}</td>
				</tr>
				<tr>
					<th>快递单号</th>
					<td>{{detailModel.expNo}}</td>
				</tr>
				<tr>
					<th>邮寄省份名称</th>
					<td>
						{{detailModel.expProvinceName}}
					</td>
				</tr>
				<tr>
					<th>邮寄城市名称</th>
					<td>{{detailModel.expCityName}}</td>
				</tr>
				<tr>
					<th>邮寄区县名称</th>
					<td>{{detailModel.expDistrictName}}</td>
				</tr>
				<tr>
					<th>邮寄地址</th>
					<td>{{detailModel.expAddress}}</td>
				</tr>
				<tr>
					<th>邮寄状态</th>
					<td>
						<span v-if="detailModel.expStatus=='0'">不邮寄</span>
						<span v-if="detailModel.expStatus=='1'">待邮寄</span>
						<span v-if="detailModel.expStatus=='2'">已发货</span>
					</td>
				</tr>
			</table>
		</el-dialog>
		<!--详情弹窗-->
		<el-dialog :title="remindTitle" :visible.sync="remindDialog" width="40%" @close="closeRemind">
			<el-form :inline="true" class="add-dialog">
				<el-form-item label="确认提醒内容">
					<el-input :rows="4" type="textarea" disabled
						v-model="remindContent"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="flex-end">
						<el-button size="mini" type="primary" @click="remindDialog=false">取消</el-button>
						<el-button size="mini" type="primary" @click="toConfirmRemind">确定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!--选择城市-->
		<el-dialog title="选择城市" :visible.sync="cityDialog" width="40%" @close="closeRemind">
			<div class="city-wrap">
				<ul class="citylist">
					<li :class="[item.id==proviceId?'active':'']" v-for="item in proviceList" @click="selectProvice(item)">
						{{item.keyName}}
					</li>
				</ul>
				<ul class="citylist">
					<li :class="[item.id==cityId?'active':'']" v-for="item in cityList" @click="selectCity(item)">
						{{item.keyName}}
					</li>
				</ul>
				<ul class="citylist">
					<li :class="[item.id==countryId?'active':'']" v-for="item in countryList" @click="selectCountry(item)">
						{{item.keyName}}
					</li>
				</ul>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	import qs from 'qs'
	import { post, config, ajaxParam } from '@/units/request.js'
import axios from 'axios'
	export default {
		name: 'FeedList',
		components: {
			Title,
			Pagination
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dataList: [],
				vacationId: '',
				vacationName: '',
				countModel: {},
				currentIndex: 1,
				enrollDialog: false,
				logisticsDialog: false,
				remindDialog: false,
				checkDialog: false,
        expStatus: 0,
				checkLogisticsCnt: '',
				detailModel: {},
				remindTitle: '',
				remindContent: '',
				remindIndex: '',
				multipleSelection: [],
				cityDialog: false,
				formInfo: {
					userName: '',
					nickName: '',
					memberPhone: '',
					school: '',
					enrollTime: '',
					starFlag: '', //标星  1是 0否
					regionIds: '', //返乡城市ids
					returnAddress: '', //返乡地址
					auditStatus: '', //审核状态(0,未审核1审核通过2审核未通过
					joinStatus: ''
				},
				regionType: 1, //1.省 2.市 3.区，县
				parentId: '',
				options: [],
				proviceList: [],
				cityList: [],
				countryList: [],
				proviceId: '',
				cityId: '',
				countryId: '',
				proviceName: '',
				cityName: '',
				countryName: ''
			}
		},
		created(){
			this.vacationId = this.$route.query.id||''
			this.getDataList()
			this.getCountInfo()
			this.getProvinceList()
		},
		methods: {
			//获取统计信息
			async getCountInfo() {
				let param = {
					vacationId: this.vacationId,
					userName: this.formInfo.userName,
					nickName: this.formInfo.nickName,
					memberPhone: this.formInfo.memberPhone,
					school: this.formInfo.school,
					enrollTime: this.formInfo.enrollTime,
					starFlag: this.formInfo.starFlag,
					returnAddress: this.formInfo.returnAddress,
					auditStatus: this.formInfo.auditStatus,
					joinStatus: this.formInfo.joinStatus,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/enroll/getStatusCountBySearch', qs.stringify(param))
				if (res.data.code == 200) {
					this.countModel = res.data.entity
				}
			},
			//获取审核列表
			async getDataList() {
				let param = {
					vacationId: this.vacationId,
					userName: this.formInfo.userName,
					nickName: this.formInfo.nickName,
					memberPhone: this.formInfo.memberPhone,
					school: this.formInfo.school,
					enrollTime: this.formInfo.enrollTime,
					starFlag: this.formInfo.starFlag,
					regionIds: this.formInfo.regionIds,
					returnAddress: this.formInfo.returnAddress,
					auditStatus: this.formInfo.auditStatus,
					joinStatus: this.formInfo.joinStatus,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/enroll/list', qs.stringify(param))
				if (res.data.code == 200) {
					this.dataList = res.data.page.items
					this.total = res.data.page.count
					this.vacationName = res.data.vacationName
					this.vacationId = res.data.vacationId
				}
			},
			//分页
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			toSearch(){
				this.getDataList()
				this.getCountInfo()
			},
			toReset(){
				this.formInfo.userName = ''
				this.formInfo.nickName = ''
				this.formInfo.school = ''
				this.formInfo.memberPhone = ''
				this.formInfo.starFlag = ''
				this.formInfo.returnAddress = ''
				this.formInfo.enrollTime = ''
				this.formInfo.regionIds = ''
				this.proviceId = ''
				this.cityId = ''
				this.countryId = ''
				this.proviceName = ''
				this.cityName = ''
				this.countryName = ''
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
				this.getCountInfo()
			},
			changeTab(index) {
				this.currentIndex = index
				this.formInfo.joinStatus = ''
				this.formInfo.auditStatus = ''
				if(index==0) {
					this.formInfo.auditStatus = -1
				} else if(index==1) {
					this.formInfo.auditStatus = 0
				} else if(index==2) {
					this.formInfo.auditStatus = 1
				} else if(index==3){
					this.formInfo.joinStatus = 1
				} else if(index==4){
					this.formInfo.joinStatus = 0
				}
				this.getDataList()
				this.getCountInfo()
			},
			setSelectedType(e){
				this.certificateStatus = e
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			toDetail(row, index){
				//详情弹窗
				if(index==1) {
					this.enrollDialog = true
				}
				//查看物流
				if(index==2) {
					this.logisticsDialog = true
				}
				//审核邮寄
				if(index==3) {
          		this.expStatus=1
					this.checkDialog = true
					this.checkLogisticsCnt = '你参加的'+ this.vacationName +'已审核通过，请尽快确认是否参加，名额有限先到先得'
				}
				//审核
        if(index==4) {
          this.expStatus=0
          this.checkDialog = true
          this.checkLogisticsCnt = '你参加的'+ this.vacationName +'已审核通过，请尽快确认是否参加，名额有限先到先得'
        }

				this.getDetailData(row.id)
			},
			//获取详情
			async getDetailData(id) {
				let param = {
					id: id,
				}
				ajaxParam(param)
				const res = await post('admin/enroll/detail', qs.stringify(param))
				if (res.data.code == 200) {
					this.detailModel = res.data.entity
				}
			},
			closeRemind(){
				this.remindDialog = false
				this.remindIndex = ''
			},
			toRemindCheck(index){
				this.remindDialog = true
				if(index==1){
					//审核确认提醒
					this.remindTitle = '确定发送审核未确认短信提醒吗？'
					this.remindContent = '你报名参加的'+ this.vacationName +'活动已审核通过，请尽快确认是否参加'
					this.remindIndex = 1
				}
				if(index==2){
					//任务未完成提醒
					this.remindTitle = '确定发送任务未完成短信提醒吗？'
					this.remindContent = '你参加的'+ this.vacationName +'活动任务未完成，请尽快完成'
					this.remindIndex = 2
				}
			},
			toConfirmRemind(){
				if(this.remindIndex==1) {
					this.toConfirmCheck()
				} else {
					this.toConfirmTask()
				}
			},
			//提醒审核
			async toConfirmCheck(url){
				let param = {
					vacationId: this.vacationId,
					confirmRemind: this.remindContent
				}
				ajaxParam(param)
				const res = await post('admin/enroll/updateConfirmRemind', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('操作成功！')
					this.closeRemind()
					this.getCountInfo()
					this.getDataList()
				} else {
					this.$message.error(res.data.msg)
					this.closeRemind()
				}
			},
			//提醒任务
			async toConfirmTask(url){
				let param = {
					vacationId: this.vacationId,
					taskRemind: this.remindContent
				}
				ajaxParam(param)
				const res = await post('admin/enroll/updateTaskRemind', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('操作成功！')
					this.closeRemind()
					this.getCountInfo()
					this.getDataList()
				} else {
					this.$message.error(res.data.msg)
					this.closeRemind()
				}
			},
			//邮寄审核
			async toConfirmLog(){
				let param = {
					id: this.detailModel.id,
         			expStatus: this.expStatus,
					auditStatus: 1,
					auditRemind: this.checkLogisticsCnt
				}
				ajaxParam(param)
				const res = await post('admin/enroll/updateEnrollStatus', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('操作成功！')
					this.checkDialog = false
					this.getCountInfo()
					this.getDataList()
				}
			},
			//导出地址
			downAddress(){
				let title = ''
				let url = ''
				if(this.multipleSelection.length>0) {
					title = '确定导出模块为报名选中的记录吗？'
					let ids = []
					this.multipleSelection.forEach(item=>{
						console.log(item.id)
						ids.push(item.id)
					})
					url = 'admin/enroll/downloadAddressResult?ids='+ids.join(',')+'&vacationId='+this.vacationId
				} else {
					title = '确定导出模块为报名符合查询条件的所有记录吗？'
					url = 'admin/enroll/downloadAddressResult?userName='+this.formInfo.userName+'&nickName='+this.formInfo.nickName+'&memberPhone='+this.formInfo.memberPhone+'&school='+this.formInfo.school+'&auditStatus='+this.formInfo.auditStatus+'&joinStatus='+this.formInfo.joinStatus+'&starFlag='+this.formInfo.starFlag+'&enrollTime='+this.formInfo.enrollTime+'&vacationId='+this.vacationId
				}
				this.$confirm(title,'温馨提示',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let downUrl = config.baseUrl + url
					window.location.href = downUrl
				}).catch(() => {

				})
			},
			//导出入选信息
			downJoin(){
				let title = ''
				let url = ''
				if(this.multipleSelection.length>0) {
					title = '确定导出模块为报名选中的记录吗？'
					let ids = []
					this.multipleSelection.forEach(item=>{
						console.log(item.id)
						ids.push(item.id)
					})
					url = 'admin/enroll/downloadResult?ids='+ids.join(',')+'&vacationId='+this.vacationId
				} else {
					title = '确定导出模块为报名符合查询条件的所有记录吗？'
					url = 'admin/enroll/downloadResult?userName='+this.formInfo.userName+'&nickName='+this.formInfo.nickName+'&memberPhone='+this.formInfo.memberPhone+'&school='+this.formInfo.school+'&auditStatus='+this.formInfo.auditStatus+'&joinStatus='+this.formInfo.joinStatus+'&starFlag='+this.formInfo.starFlag+'&enrollTime='+this.formInfo.enrollTime+'&vacationId='+this.vacationId
				}
				this.$confirm(title,'温馨提示',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let downUrl = config.baseUrl + url
					window.location.href = downUrl
				}).catch(() => {

				})
			},
			//上传物流信息
			uploadFile(e){
				console.log('eeeeeeee')
				console.log(e)
				console.log(e.target.files[0])
				var file =  e.target.files[0]
				//上传文件、图片类型一般以二进制传递
				let formData = new FormData()
				// 向 FormData 中添加新的属性值 append()方法
				formData.append('file',file)
				console.log(formData)
				let url = config.baseUrl+'admin/sys/upload'
				axios.post(url, formData).then(res=>{
					//文件上传成功后获取地址
					this.saveFile(res.data.entity.fileUrl)
				})
			},
			//
			async saveFile(url){
				let param = {
					excelFileUrl: url
				}
				ajaxParam(param)
				const res = await post('admin/enroll/readExcel', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('操作成功！')

				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
				console.log(this.multipleSelection)
			},
			//获取地区
			async getProvinceList() {
				let param = {
					regionType: this.regionType,
					parentId: this.parentId
				}
				ajaxParam(param)
				const res = await post('admin/sys/regionList', qs.stringify(param))
				if (res.data.code == 200) {
					this.proviceList= res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			selectProvice(item){
				this.proviceName = item.keyName
				this.proviceId = item.id
				this.getCityList(item.id, 2)
				this.formInfo.regionIds = this.proviceId+','
				this.cityList = []
				this.countryList = []
				this.cityId = ''
				this.countryId = ''
				this.cityName = ''
				this.countryName = ''
			},
			selectCity(item){
				this.cityName = item.keyName
				this.cityId = item.id
				this.getcountryList(item.id, 3)
				this.formInfo.regionIds += this.cityId+','
			},
			selectCountry(item){
				this.countryName = item.keyName
				this.countryId = item.id
				this.formInfo.regionIds += this.countryId
				this.cityDialog = false
			},
			async getCityList(parentId,regionType) {
				let param = {
					regionType: regionType,
					parentId: parentId
				}
				ajaxParam(param)
				const res = await post('admin/sys/regionList', qs.stringify(param))
				if (res.data.code == 200) {
					this.cityList = res.data.list

				} else {
					this.$message.error(res.data.msg)
				}
			},
			async getcountryList(parentId,regionType) {
				let param = {
					regionType: regionType,
					parentId: parentId
				}
				ajaxParam(param)
				const res = await post('admin/sys/regionList', qs.stringify(param))
				if (res.data.code == 200) {
					this.countryList = res.data.list

				} else {
					this.$message.error(res.data.msg)
				}
			},
			toSelectCity() {
				this.cityDialog = true
			}
		}
	}
</script>

<style scoped lang="less">
	@import url("../../table.less");
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}
	.export-wrap{
		display: flex;
		justify-content: space-between;
		padding: 10px 0 15px;
		.export-wrap-l{
			/deep/ .el-button--primary {
				background: #999;
				border-color: #999;
			}
			/deep/ .el-button--primary.current{
				background: #EB6B1B;
				border-color: #EB6B1B;
			}
		}
		.export-wrap-r{
			display: flex;
			//上传物流
			.upload-logistics{
				position: relative;
				margin-left: 10px;
				margin-right: 10px;
				overflow: hidden;
				input{
					display: inline;
					position: absolute;
					left: 0;
					font-size: 17px!important;
					opacity: 0;
				}
			}
		}
		/deep/ .el-button--mini{
			padding: 4px 4px;
		}
	}
	.star-icon{
		font-size: 18px;
		color: #999
	}

	/deep/ .el-form-item {
		margin-bottom: 0;
	}
	/deep/ .activity-form-wrap .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px!important;
	}

	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}

	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 5px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}
	/deep/ .el-dialog__header {
		padding-top: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #DBDCDC !important;
	}
	/deep/ .el-dialog__body {
		padding-top: 10px;
	}
	.el-dialog__wrapper /deep/ .el-form--inline .el-form-item{
		width: 100%;
		display: flex;
	}
	.el-dialog__wrapper /deep/ .el-form-item__content{
		flex: 1
	}
	.el-dialog__wrapper /deep/ .el-textarea.is-disabled .el-textarea__inner {
	    color: #333;
	}
	/deep/ .el-date-editor.el-input, /deep/ .el-date-editor.el-input__inner{
		width: 160px;
	}
	.flex-end{
		display: flex;
		justify-content: flex-end;
		margin-top: 15px;
	}
	.manage-btns{
		color: #EB6B1B;
		span{
			cursor: pointer;
		}
		.space{
			margin: 0 5px;
			cursor: default;
		}
	}
	.city-wrap{
		display: flex;
		height: 300px;
		overflow-y: auto;
		.citylist{
			width: 33%;
			li{
				height: 22px;
				padding: 0 12px;
				box-sizing: border-box;
				line-height: 22px;
				font-size: 12px;
				cursor: pointer;
			}
			li.active, li:hover{
				background: #f5f7fa;
				color: #409eff;
			}
		}
	}
</style>
